import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { pdfStyles } from './pdfStyles';

export default function OfferPDFFooter() {
  return (
    <View style={pdfStyles.footer} fixed>
      <Text>Generated {new Date().toISOString().slice(0, 10)}</Text>
      <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
    </View>
  );
}
